import TouchFriendlyCandidateAvailability from 'candidate_availability/touch_friendly_candidate_availability';
import Mounter from 'shared/utils/mounter';
import flagDeviceTypeOnDomReady from 'candidate_availability/flag_device_type';
import { setTimeZoneLabel } from 'shared/full_calendar_helpers';

import documentReady from 'document-ready';

documentReady(() => {
  // Assign globals to interact with asset-pipeline javascript
  window.Availability = window.Availability || {};
  window.Availability.setTimeZoneLabel = setTimeZoneLabel;

  // add class that marks whether its a touchscreen based device or not. This is used in the css
  // to ensure only the appropriate view is shown (since the desktop is done in traditional, non ES6
  // code
  flagDeviceTypeOnDomReady();

  // register all the components and have em ready on page load
  new Mounter({ TouchFriendlyCandidateAvailability }).mountAll();
});
